var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "tabs",
            fn: function () {
              return [
                _c(
                  "el-tabs",
                  {
                    staticClass: "bg-white",
                    on: {
                      "tab-click": function ($event) {
                        delete _vm.form.search_goods_type
                        _vm.toQuery()
                      },
                    },
                    model: {
                      value: _vm.listQuery.search_goods_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "search_goods_type", $$v)
                      },
                      expression: "listQuery.search_goods_type",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: {
                        label: "全部(" + _vm.total_device_num + ")",
                        name: "-1",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.tabDevice, function (item, index) {
                      return item.is_delete == 0
                        ? _c("el-tab-pane", {
                            attrs: {
                              label:
                                item.type_name +
                                (_vm.type_device_num[item.depend_type] >= 0
                                  ? "(" +
                                    _vm.type_device_num[item.depend_type] +
                                    ")"
                                  : ""),
                              name: "" + item.depend_type + "",
                            },
                          })
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "商户名称:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_store_name", $$v)
                        },
                        expression: "form.search_store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "二维码:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_goods_sn", $$v)
                        },
                        expression: "form.search_goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "设备SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_device_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_device_id", $$v)
                        },
                        expression: "form.search_device_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "宝序列号:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_bao_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_bao_sn", $$v)
                        },
                        expression: "form.search_bao_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.listQuery.search_goods_type == 3
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "设备类型:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.form.search_device_factory_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "search_device_factory_id",
                                  $$v
                                )
                              },
                              expression: "form.search_device_factory_id",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "10路桩", value: "DianLaLa104G" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "16路桩",
                                value: "DianLaLa16TCP4G",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "2路4G", value: "DianLaLa4G" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "2路蓝牙", value: "DianLaLaBLE" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "2路大功率",
                                value: "DianLaLaHP4G",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "2路刷卡2200瓦",
                                value: "DianLaLaS4G",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary", "native-type": "submit" } },
                  [
                    _vm._v("查询"),
                    _c("i", { staticClass: "el-icon-search el-icon--right" }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "warning", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.toQuery(1)
                      },
                    },
                  },
                  [
                    _vm._v("重置"),
                    _c("i", { staticClass: "el-icon-refresh el-icon--right" }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.outTab("equip_table", "设备记录")
                      },
                    },
                  },
                  [
                    _vm._v("导出"),
                    _c("i", { staticClass: "el-icon-male el-icon--right" }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _vm.checkRoles(["terminal"])
                  ? _c("sel-plat", {
                      attrs: { listQuery: _vm.listQuery },
                      on: {
                        change: function ($event) {
                          return _vm.toQuery()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.all
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "用户类型:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.search_user_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "search_user_type", $$v)
                              },
                              expression: "listQuery.search_user_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "我的设备", value: 0 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "下级设备", value: 1 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "底座SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_device_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_device_id", $$v)
                        },
                        expression: "form.search_device_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user_type == 1
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "代理姓名:" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.search_agent_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "search_agent_name", $$v)
                            },
                            expression: "form.search_agent_name",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-5" },
        [
          _c("div", { staticClass: "flex bg-white" }, [
            _c(
              "div",
              { staticClass: "flex1" },
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "mb-0",
                    attrs: { type: "card" },
                    on: { "tab-click": _vm.typeClick },
                    model: {
                      value: _vm.listQuery.device_status,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "device_status", $$v)
                      },
                      expression: "listQuery.device_status",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: {
                        label: "全部(" + (_vm.numInfo.all_num || 0) + ")",
                        name: "0",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-tab-pane", {
                      attrs: {
                        label: "在线(" + (_vm.numInfo.online_num || 0) + ")",
                        name: "1",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-tab-pane", {
                      attrs: {
                        label:
                          "离线(" + (_vm.numInfo.not_online_num || 0) + ")",
                        name: "2",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-tab-pane", {
                      attrs: {
                        label:
                          "已绑(" + (_vm.numInfo.distributed_num || 0) + ")",
                        name: "4",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-tab-pane", {
                      attrs: {
                        label:
                          "未绑(" +
                          (_vm.numInfo.not_distributed_num || 0) +
                          ")",
                        name: "5",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pb-5 pr-15",
                staticStyle: {
                  "padding-top": "4px",
                  "border-bottom": "1px solid #E4E7ED",
                },
              },
              [
                _vm.checkRoles(["terminal"])
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.showUpgrade(_vm.systemUpgrade)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.systemUpgrade.upgrade_status == 2
                              ? "升级设备中"
                              : "设备升级"
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkRoles(["terminal"])
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "primary",
                          plain: "",
                          disabled: _vm.selID.length == 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.costPrice()
                          },
                        },
                      },
                      [_vm._v("设备成本")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.checkRoles(["terminal"])
                  ? [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            plain: "",
                            disabled: _vm.selSnArr.length == 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.distribu()
                            },
                          },
                        },
                        [_vm._v("去铺货")]
                      ),
                      _vm._v(" "),
                      _vm.agent_id
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                                disabled: _vm.selSnArr.length == 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.distribu(3)
                                },
                              },
                            },
                            [_vm._v("点此分配")]
                          )
                        : _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                                disabled: _vm.selSnArr.length == 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.distribu(2)
                                },
                              },
                            },
                            [_vm._v("去分配")]
                          ),
                      _vm._v(" "),
                      _vm.ad_id
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                                disabled: _vm.selSnArr.length == 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.bindAd()
                                },
                              },
                            },
                            [_vm._v("绑定广告")]
                          )
                        : _vm.listQuery.son_id
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "danger",
                                plain: "",
                                disabled: _vm.selSnArr.length == 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.distribu(4)
                                },
                              },
                            },
                            [_vm._v("回收设备")]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bg-white" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: "equip-table-" + _vm.listQuery.search_goods_type,
                  ref: "equip_table",
                  staticClass: "ptd-5",
                  attrs: {
                    id: "equip_table",
                    data: _vm.list,
                    "element-loading-text": "Loading",
                    stripe: "",
                    "highlight-current-row": "",
                    "max-height": _vm.tableMaxH,
                  },
                  on: { "selection-change": _vm.selSb },
                },
                [
                  _vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { type: "selection", width: "50" },
                      })
                    : _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          selectable: _vm.checkSel,
                          width: "50",
                        },
                      }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "设备名称", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.goods_name) +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.user_type == 1
                    ? _c("el-table-column", {
                        attrs: { label: "设备归属", width: "180" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.manage_name) +
                                        "（" +
                                        _vm._s(scope.row.manage_role_name) +
                                        "）"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.manage_phone)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3208475294
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "设备SN码", width: "230" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "二维码：" + _vm._s(scope.row.goods_sn || "--")
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-cut" }, [
                              _vm._v(
                                "设备SN：" + _vm._s(scope.row.device_id || "--")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "可借|可还", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.goods_type == 1
                              ? _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(scope.row.rent_num) +
                                      " | " +
                                      _vm._s(scope.row.back_num) +
                                      "\n              "
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    "\n                --\n              "
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "流量卡号", width: "190" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.device_card_num || "--") +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "信号值",
                      width: "50",
                      "render-header": _vm.renderHeader,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.device_signal || "--") +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "是否铺货", width: "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row.is_distributed == 1 ? "是" : "否"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(scope.row.operate_date))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商户名称", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "text-cut_two" }, [
                              _vm._v(_vm._s(scope.row.store_name || "--")),
                            ]),
                            _vm._v(" "),
                            scope.row.attach_room_no
                              ? _c("div", [
                                  _vm._v(
                                    "房间号：" +
                                      _vm._s(scope.row.attach_room_no)
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.checkRoles(["terminal", "partner"])
                    ? _c("el-table-column", {
                        attrs: { label: "订单数", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _vm._v("微信："),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                path:
                                                  (_vm.user_type == 0
                                                    ? "/order/meOrder"
                                                    : "/order/subOrder") +
                                                  "?goods_sn=" +
                                                  scope.row.goods_sn +
                                                  "&mini_type=1",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.wx_mini_num))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _vm._v("支付宝："),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                path:
                                                  (_vm.user_type == 0
                                                    ? "/order/meOrder"
                                                    : "/order/subOrder") +
                                                  "?goods_sn=" +
                                                  scope.row.goods_sn +
                                                  "&mini_type=2",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.zfb_mini_num))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2706459655
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkRoles(["terminal", "partner"]) &&
                  _vm.showElectricityColumn
                    ? _c("el-table-column", {
                        key:
                          "electricity-col-" + _vm.listQuery.search_goods_type,
                        attrs: { label: "用电度数", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.goods_type == 5
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.total_kwh != null
                                              ? scope.row.total_kwh
                                              : 0
                                          ) + "度"
                                        ),
                                      ])
                                    : _c("span", [_vm._v("--")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1428231020
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkRoles(["terminal", "partner"])
                    ? _c("el-table-column", {
                        attrs: { label: "交易额", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              ￥" +
                                      _vm._s(scope.row.order_amount) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          480331173
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { label: "设备成本", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              ￥" +
                                      _vm._s(scope.row.cost_price) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4216673281
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "心跳状态", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            [3, 9, 10].indexOf(scope.row.goods_type) > -1
                              ? _c("div", [
                                  _vm._v(
                                    "\n                --\n              "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type:
                                            scope.row.device_state == 1
                                              ? "primary"
                                              : "danger",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.deviceState[
                                                scope.row.device_state
                                              ]
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "掉线|上线日志", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showOnlineLog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "掉线|上线天数", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row.synchronize_updated
                                    ? (scope.row.synchronize_status == 1
                                        ? "在线"
                                        : "掉线") +
                                        Math.floor(
                                          (Date.now() / 1000 -
                                            scope.row.synchronize_updated) /
                                            86400
                                        ) +
                                        "天"
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "200",
                      fixed: _vm.device == "desktop" ? "right" : false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  plain: "",
                                  round: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.equipBelong(scope.row)
                                  },
                                },
                              },
                              [_vm._v("设备归属")]
                            ),
                            _vm._v(" "),
                            scope.row.goods_type == 1 &&
                            !_vm.checkRoles(["terminal"])
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          path:
                                            "/equipment/popup/" +
                                            scope.row.goods_sn,
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("设备弹出")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.listQuery.search_user_type == 0
                              ? [
                                  scope.row.is_distributed == 1
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.distribu(5, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("房间号")]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.distribu(1, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("去 铺 货")]
                                      ),
                                  _vm._v(" "),
                                  _vm.agent_id && scope.row.is_distributed == 0
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.distribu(3, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("分配设备")]
                                      )
                                    : scope.row.is_distributed == 0
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.distribu(2, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("分配设备")]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.is_distributed == 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteEquip(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 解  绑 ")]
                                )
                              : _vm.listQuery.search_user_type == 1 &&
                                scope.row.is_distributed == 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.distribu(4, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("回收设备")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ad_id
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.bindAd(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("绑定广告")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "ml-0",
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  plain: "",
                                  round: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showCode(scope.row)
                                  },
                                },
                              },
                              [_vm._v("二维码")]
                            ),
                            _vm._v(" "),
                            _vm.checkRoles(["terminal"])
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.costPrice(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("设备成本")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.device_factory_id == "DianLaLa104G" ||
                            scope.row.device_factory_id == "DianLaLa124G" ||
                            scope.row.device_factory_id == "DianLaLa164G" ||
                            scope.row.device_factory_id == "DianLaLa16TCP4G"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      size: "mini",
                                      type: "primary",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createImg(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("插座码")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.goods_type == 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.restart(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("重启设备")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.goods_type == 5 &&
                            scope.row.synchronize_status == 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.restartPile(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("远程重启")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex justify-center" },
                [
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.listQuery.page_num > 0,
                        expression: "listQuery.page_num > 0",
                      },
                    ],
                    attrs: {
                      page: _vm.listQuery.start,
                      "page-count": _vm.listQuery.page_num,
                      limit: _vm.listQuery.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listQuery, "start", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listQuery, "limit", $event)
                      },
                      pagination: _vm.getList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "设备归属", visible: _vm.equipBelongDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.equipBelongDialog = $event
                },
              },
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.eqiupBelong } },
                [
                  _c("el-table-column", {
                    attrs: { label: "角色", property: "role_name" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "联系信息" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.checkRoles(["terminal", "partner"])
                              ? _c("div", [
                                  _vm._v(
                                    "姓名：" +
                                      _vm._s(scope.row.name) +
                                      "    电话：" +
                                      _vm._s(scope.row.phone)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.agent_level == 5
                              ? _c("div", [
                                  _vm._v(
                                    "商户名：" +
                                      _vm._s(_vm.eqiupStore.store_name)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.agent_level == 5
                              ? _c("div", [
                                  _vm._v(
                                    "地址：" + _vm._s(_vm.eqiupStore.address)
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "设备弹出", visible: _vm.baoDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.baoDialog = $event
                },
              },
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.baoList } },
                [
                  _c("el-table-column", {
                    attrs: { label: "卡槽位置", property: "cang_num" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "电池编号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.bao_sn || "--"))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "电池电量" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.electricity
                                  ? scope.row.electricity + "%"
                                  : "--"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "弹出次数" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(scope.row.used_num || "--"))]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "在线状态" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.statusArr[scope.row.bao_status] || "已弹出"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  plain: "",
                                  round: "",
                                  disabled: scope.row.bao_status != 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.equipPopup(scope.row)
                                  },
                                },
                              },
                              [_vm._v("弹出")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "设备升级", visible: _vm.upgradeDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.upgradeDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  !_vm.upgradeObj.goods_sn
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "升级设备：" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.upgradeObj.updating_depend,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.upgradeObj,
                                    "updating_depend",
                                    $$v
                                  )
                                },
                                expression: "upgradeObj.updating_depend",
                              },
                            },
                            _vm._l(_vm.deviceNameObj, function (item, key) {
                              return _c(
                                "el-checkbox-button",
                                { attrs: { label: item } },
                                [_vm._v(_vm._s(key))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "升级状态：" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 2, "inactive-value": 1 },
                        model: {
                          value: _vm.upgradeObj.upgrade_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.upgradeObj, "upgrade_status", $$v)
                          },
                          expression: "upgradeObj.upgrade_status",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "升级提示语：" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: "4" },
                        model: {
                          value: _vm.upgradeObj.upgrade_desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.upgradeObj, "upgrade_desc", $$v)
                          },
                          expression: "upgradeObj.upgrade_desc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.setUpgrade()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "掉线/上线日志",
                visible: _vm.onlineLogDialog,
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.onlineLogDialog = $event
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.onlineLogList, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "device_time", label: "时间", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.parseTime(
                                    scope.row.device_time,
                                    "{y}-{m}-{d} {h}:{i}:{s}"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.type == 1 ? "success" : "danger",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      scope.row.type == 1 ? "上线" : "掉线"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "device_id", label: "设备ID" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.onlineLogQuery.page_num > 0,
                    expression: "onlineLogQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.onlineLogQuery.start,
                  limit: _vm.onlineLogQuery.limit,
                  "page-count": _vm.onlineLogQuery.page_num,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.onlineLogQuery, "start", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.onlineLogQuery, "limit", $event)
                  },
                  pagination: _vm.getOnlineLogList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }